import { useQueryClient } from "@tanstack/react-query";
import type { TransferOrderResponse } from "../../api_utils/types";
import React, { useMemo } from "react";
import { useTransferOrder } from "../../api_utils/requests";
import { getIdFromPath } from "../../helper_functions/utils";
import { TransferOrderShowPageSkeleton } from "../common/skeletons";

import TransferOrderDraft from "./Draft";
import TransferOrderSent from "./Sent";
import TransferOrderReceived from "./Received";

function Show(): React.JSX.Element {
  const transferOrderId = useMemo(() => getIdFromPath(), []);

  const { data, isLoading: pageLoading } = useTransferOrder(transferOrderId);
  const { origin, destination, transferOrder, lineItems } = data;

  const queryClient = useQueryClient();
  const onSave = (response: TransferOrderResponse): void => { queryClient.setQueryData(["transfer_order", transferOrderId], response); };

  const commonProps = {
    origin,
    destination,
    transferOrder,
    onSave,
    lineItems,
  };

  const renderPageContent = (): React.JSX.Element => {
    if (!transferOrder) return null;

    const { state } = transferOrder;
    const ComponentMap = {
      draft: TransferOrderDraft,
      sent: TransferOrderSent,
      received: TransferOrderReceived,
    };

    const SelectedComponent = ComponentMap[state];

    return SelectedComponent ? <SelectedComponent {...commonProps} /> : null;
  };

  return pageLoading ? <TransferOrderShowPageSkeleton /> : renderPageContent();
}

export default Show;
